import {
    CALENDAR_IDS_SUCCESS,
    CALENDAR_IDS_ERROR,
} from '../../actions/Calendar/getCalendarIdsAction';
import {
    CALENDAR_PRIMARY_EVENTS_SUCCESS,
    CALENDAR_PRIMARY_EVENTS_ERROR
} from '../../actions/Calendar/getPrimaryEventsAction';
import {
    CALENDAR_GT_EVENTS_SUCCESS,
    CALENDAR_GT_EVENTS_ERROR
} from '../../actions/Calendar/getGlobalTasksEventsAction';
import {
    CALENDAR_TIMETABLE_EVENTS_SUCCESS,
    CALENDAR_TIMETABLE_EVENTS_ERROR
} from '../../actions/Calendar/getTimetableEventsAction';
import {
    ADD_EVENT_SUCCESS,
    ADD_EVENT_ERROR
} from '../../actions/Calendar/addEventAction';
import {
    UPDATE_EVENT_SUCCESS,
    UPDATE_EVENT_ERROR
} from '../../actions/Calendar/updateEventAction';
import {
    DELETE_EVENT_SUCCESS,
    DELETE_EVENT_ERROR
} from '../../actions/Calendar/deleteEventAction';
import {
    LATEST_GT_EVENTS_SUCCESS,
    LATEST_GT_EVENTS_ERROR
} from '../../actions/Calendar/getLatestGtEventsAction';
import {
    LATEST_PRIMARY_EVENTS_SUCCESS,
    LATEST_PRIMARY_EVENTS_ERROR
} from '../../actions/Calendar/getLatestPrimaryEventsAction';
import {
    LATEST_TIMETABLE_EVENTS_SUCCESS,
    LATEST_TIMETABLE_EVENTS_ERROR
} from '../../actions/Calendar/getLatestTimetableEventsAction';
import {
    DELETE_TIMETABLE_SUCCESS,
    DELETE_TIMETABLE_ERROR
} from '../../actions/Calendar/deleteTimetableAction';

import _ from 'lodash';

import {
    IMPORT_TIMETABLE_FROM_FILE_SUCCESS,
    IMPORT_TIMETABLE_FROM_FILE_ERROR
} from '../../actions/Calendar/importTimetableFromFileAction';
import {
    IMPORT_TIMETABLE_FROM_URL_SUCCESS,
    IMPORT_TIMETABLE_FROM_URL_ERROR
} from '../../actions/Calendar/importTimetableFromUrlAction';

import { GET_TIMETABLE_URL_SUCCESS } from '../../actions/Calendar/getTimetableUrlAction';
import {
    addSyncEvent,
    updateSyncEvent,
    deleteSyncEvent,
    mergeSyncEvents,
    determineEventArrayType
} from '../../../utils/eventHelpers';
import { SYNC_EVENT_ADDED, SYNC_EVENT_UPDATED, SYNC_EVENT_DELETED } from '../../actions/Calendar/syncCalendarEventsAction';

import { DISCONNECT_CALENDAR_SUCCESS } from '../../actions/Calendar/disconnectCalendarAction';





const initialState = {
    calendarIds: [],
    primaryEvents: [],
    gtEvents: [],
    timetableFileEvents: [],
    timetableUrlEvents: [],
    deletingEvent: [],
    updatingEvent: [],
    addingEvent: [],
    eventsLoaded: false,
    timetableImported: false,
    timetableImportError: '',
    error: null,
    timetableUrl: '',
};


const getCalendarEventsReducer = (state = initialState, action) => {
    // Only log calendar-specific actions (removed noisy logging that fired for every Redux action)
    switch (action.type) {
        case CALENDAR_IDS_SUCCESS:
            return {
                ...state,
                eventsLoaded: false,
                calendarIds: action.payload,
            };
        case CALENDAR_IDS_ERROR:
            return {
                ...state,
                eventsLoaded: false,
                error: action.payload,
            };
        case CALENDAR_GT_EVENTS_SUCCESS:
            return {
                ...state,
                eventsLoaded: true,
                gtEvents: action.payload,
            };
        case CALENDAR_GT_EVENTS_ERROR:
            return {
                ...state,
                eventsLoaded: false,
                error: action.payload,
            };
        case CALENDAR_TIMETABLE_EVENTS_SUCCESS:
            return {
                ...state,
                eventsLoaded: true,
                timetableFileEvents: action.payload,
            };
        case CALENDAR_TIMETABLE_EVENTS_ERROR:
            return {
                ...state,
                eventsLoaded: false,
                error: action.payload,
            };
        case CALENDAR_PRIMARY_EVENTS_SUCCESS:
            return {
                ...state,
                eventsLoaded: true,
                primaryEvents: action.payload,
            };
        case CALENDAR_PRIMARY_EVENTS_ERROR:
            return {
                ...state,
                eventsLoaded: false,
                error: action.payload,
            };
        case ADD_EVENT_SUCCESS:
            return {
                ...state,
                eventsLoaded: true,
                addingEvent: action.payload,
            };
        case ADD_EVENT_ERROR:
            return {
                ...state,
                eventsLoaded: false,
                error: action.payload,
            };
        case "RESET_TIMETABLE_TOAST":
            return {
                ...state,
                timetableImported: action.payload
            };
        case UPDATE_EVENT_SUCCESS:
            return {
                ...state,
                eventsLoaded: true,
                updatingEvent: action.payload,
            };
        case UPDATE_EVENT_ERROR:
            return {
                ...state,
                eventsLoaded: false,
                error: action.payload,
            };
        case DELETE_EVENT_SUCCESS:
            return {
                ...state,
                eventsLoaded: true,
                deletingEvent: action.payload,
            };
        case DELETE_EVENT_ERROR:
            return {
                ...state,
                eventsLoaded: false,
                error: action.payload,
            };
        case LATEST_GT_EVENTS_SUCCESS:
            const newGTEvents = action.payload.items || action.payload;
            const existingGTEvents = _.cloneDeep(state.gtEvents || {});
            const mergedGTEvents = mergeSyncEvents(existingGTEvents, newGTEvents);
            return {
                ...state,
                eventsLoaded: true,
                gtEvents: mergedGTEvents
            };
        case LATEST_GT_EVENTS_ERROR:
            return {
                ...state,
                eventsLoaded: false,
                error: action.payload,
            };
        case LATEST_PRIMARY_EVENTS_SUCCESS:
            const newPrimaryEvents = action.payload.items || action.payload;
            const existingPrimaryEvents = _.cloneDeep(state.primaryEvents || {});
            const mergedPrimaryEvents = mergeSyncEvents(existingPrimaryEvents, newPrimaryEvents);
            return {
                ...state,
                eventsLoaded: true,
                primaryEvents: mergedPrimaryEvents
            };
        case LATEST_PRIMARY_EVENTS_ERROR:
            return {
                ...state,
                eventsLoaded: false,
                error: action.payload,
            };
        case LATEST_TIMETABLE_EVENTS_SUCCESS:
            return {
                ...state,
                eventsLoaded: true,
                timetableFileEvents: action.payload
            };
        case LATEST_TIMETABLE_EVENTS_ERROR:
            return {
                ...state,
                eventsLoaded: false,
                error: action.payload,
            };
        case IMPORT_TIMETABLE_FROM_FILE_SUCCESS:
            return {
                ...state,
                eventsLoaded: true,
                timetableImported: true,
                timetableFileEvents: action.payload,
            };
        case IMPORT_TIMETABLE_FROM_FILE_ERROR:
            return {
                ...state,
                eventsLoaded: false,
                timetableImportError: action.payload,
            };
        case IMPORT_TIMETABLE_FROM_URL_SUCCESS:
            return {
                ...state,
                eventsLoaded: true,
                timetableImported: true,
                timetableUrlEvents: action.payload,
            };
        case IMPORT_TIMETABLE_FROM_URL_ERROR:
            return {
                ...state,
                eventsLoaded: false,
                timetableImportError: action.payload,
            };
        case GET_TIMETABLE_URL_SUCCESS:
            return {
                ...state,
                timetableUrl: action.payload,
            };
        case DELETE_TIMETABLE_SUCCESS:
            console.log("Entered Delete Timetable success")
            return {
                ...state,
                timetableFileEvents: [],
                timetableUrlEvents: [],
                timetableUrl: "" 
            };
        case DELETE_TIMETABLE_ERROR:
            return {
                ...state,
                error: action.payload,
            };
        case DISCONNECT_CALENDAR_SUCCESS:
            return {
                ...initialState
            };
        case SYNC_EVENT_ADDED:
            
            const addEventType = determineEventArrayType(action.payload, state.calendarIds);

            if (addEventType === 'primary') {
                return {
                    ...state,
                    primaryEvents: addSyncEvent(state.primaryEvents, action.payload),
                };
            } else if (addEventType === 'gt') {
                return {
                    ...state,
                    gtEvents: addSyncEvent(state.gtEvents, action.payload),
                };
            }
            return state;

        case SYNC_EVENT_UPDATED:
            
            const updateEventType = determineEventArrayType(action.payload, state.calendarIds);

            if (updateEventType === 'primary') {
                return {
                    ...state,
                    primaryEvents: updateSyncEvent(state.primaryEvents, action.payload),
                };
            } else if (updateEventType === 'gt') {
                return {
                    ...state,
                    gtEvents: updateSyncEvent(state.gtEvents, action.payload),
                };
            }
            return state;

        case SYNC_EVENT_DELETED:
            
            const deleteEventType = determineEventArrayType(action.payload, state.calendarIds);

            if (deleteEventType === 'primary') {
                return {
                    ...state,
                    primaryEvents: deleteSyncEvent(state.primaryEvents, action.payload.eventId),
                };
            } else if (deleteEventType === 'gt') {
                return {
                    ...state,
                    gtEvents: deleteSyncEvent(state.gtEvents, action.payload.eventId),
                };
            }
            return state;
        default:
            return state;
    }
};

export default getCalendarEventsReducer;